'use client';

import { Tag } from '@mv/web-ui';
import { cva } from 'class-variance-authority';
import { useDataTags } from '@/modules/tracking/analytics/useDataTags';
import { CallToActionGroup } from '@/payload/components/CallToActionGroup/CallToActionGroup';
import RichHeading from '@/payload/components/RichHeading/RichHeading';
import RichText from '@/payload/components/RichText/RichText';
import type { IntroBlock as Props } from '@/payload/types';
import styles from './Intro.module.scss';

const introClasses = cva(styles.intro, {
	variants: {
		alignment: {
			left: styles.leftAligned,
			center: styles.centerAligned,
		},
	},
});

export default function Intro({ blockType, id, tag, heading, content, links, link_size, alignment }: Props) {
	const { blockRef, labelRef, contentRef } = useDataTags(blockType, id);

	return (
		<div data-component="IntroBlock" ref={blockRef} className={introClasses({ alignment })}>
			{tag?.text && (
				<Tag
					className={styles.tag}
					appearance={tag?.options?.appearance ?? undefined}
					size={tag?.options?.size ?? undefined}
				>
					{tag.text}
				</Tag>
			)}
			<div className={styles.text}>
				<RichHeading
					ref={labelRef}
					content={heading.text}
					options={{
						tag: 'h2',
						styleAs: heading.options?.appearance ?? 'h2',
						textAlignment: alignment ?? 'left',
					}}
				/>
				{content && <RichText ref={contentRef} content={content} />}
			</div>
			{links && links.length > 0 && <CallToActionGroup className={styles.links} links={links} size={link_size} />}
		</div>
	);
}
